import React from "react";
import { Link } from "react-router-dom";
export default class Registration extends React.Component 
{
    render()
     {
        return<>
             <div>
           <div className="container-fluid bg-danger kpy-5 mb-5">
        <div className="container py-5">
            <div className="row align-items-center py-4">
                <div className="col-md-6 text-center text-md-left">
                    <h1 className="display-4 mb-4 mb-md-0 text-black text-uppercase">Registration</h1>
                </div>
             </div>
         </div>
      </div>

      <div className="form-container">
        <h2 className="form-heading">Registration</h2>
        <form action="#" method="POST">
          <div className="form-group">
            <label for="fullname" className="form-label"> Name</label>
            <input type="text" id="fullname" name="fullname" className="form-input" placeholder="Enter your full name" required/>
          </div>
          <div className="form-group">
            <label for="email" className="form-label">Mobile Number</label>
            <input type="email" id="number" name="email" className="form-input" placeholder="Enter your email address" required/>
          </div>
          <div className="form-group">
            <label for="email" className="form-label">Email Address</label>
            <input type="email" id="email" name="email" className="form-input" placeholder="Enter your email address" required/>
          </div>
          <div className="form-group">
            <label for="email" className="form-label">Address</label>
            <input type="Address" id="address" name="email" className="form-input" placeholder="Enter your email address" required/>
          </div>
          <div className="form-group">
            <label for="check-in-date" className="form-label">City</label>
            <input type="text" id="city" name="city" className="form-input"  placeholder="Enter City Name" required/>
          </div>
          <div className="form-group">
            <label for="room-type" className="form-label">Select State</label>
            <select id="room-type" name="room-type" className="form-input" required>
            
              <option value="">-- Select State --</option>
          <option value="Andhra Pradesh">Andhra Pradesh</option>
          <option value="Arunachal Pradesh">Arunachal Pradesh</option>
          <option value="Assam">Assam</option>
          <option value="Bihar">Bihar</option>
          <option value="Chhattisgarh">Chhattisgarh</option>
          <option value="Goa">Goa</option>
          <option value="Gujarat">Gujarat</option>
          <option value="Haryana">Haryana</option>
          <option value="Himachal Pradesh">Himachal Pradesh</option>
          <option value="Jharkhand">Jharkhand</option>
          <option value="Karnataka">Karnataka</option>
          <option value="Kerala">Kerala</option>
          <option value="Madhya Pradesh">Madhya Pradesh</option>
            </select>
          </div>
          <div className="form-group">
            <label for="fullname" className="form-label">Password</label>
            <input type="text" id="Password" name="fullname" className="form-input" placeholder="Enter Password" required/>
          </div>
          <div className="form-group">
            <label for="fullname" className="form-label">Confirm Password</label>
            <input type="text" id="Password" name="fullname" className="form-input" placeholder="Confirm Password" required/>
          </div>
       
          <div className="form-group">
         <Link to="/UserProfile"> <button type="submit" className="form-submit">REGISTER NOW </button> </Link>
          </div>
        </form>
      </div>
    </div>
    </>
     }
}
